import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import API from "@/api";
import { aiGenerateQuestionUsingPost } from "@/api/questionController";
import { Message } from "@arco-design/web-vue";

interface Props {
  appId: string;
  onSuccess?: (result: API.QuestionContentDTO[]) => void;
  onSSESuccess: (result: API.QuestionContentDTO) => void;
  onSSEStart: (event: any) => void;
  onSSEClose: (event: any) => void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AiGenerateQuestionDrawer',
  props: {
    appId: { default: () => {
    return "";
  } },
    onSuccess: {},
    onSSESuccess: {},
    onSSEStart: {},
    onSSEClose: {}
  },
  setup(__props: any) {

const visible = ref(false);
const submitting = ref(false);
const sseSubmitting = ref(false);

const handleClick = () => {
  visible.value = true;
};
const handleOk = () => {
  visible.value = false;
};
const handleCancel = () => {
  visible.value = false;
};

const props = __props;

const form = ref({
  optionNumber: 2,
  questionNumber: 10,
} as API.AiGenerateQuestionRequest);

/*
 * 提交
 * */
const handleSubmit = async () => {
  if (!props.appId) {
    return;
  }
  submitting.value = true;
  const res = await aiGenerateQuestionUsingPost({
    appId: props.appId as any,
    ...form.value,
  });
  if (res.data.code === 0 && res.data.data) {
    if (props.onSuccess) {
      props.onSuccess(res.data.data);
    } else {
      Message.success("生成题目成功");
    }
    // 关闭抽屉
    handleCancel();
  } else {
    Message.error("操作失败，" + res.data.message);
  }
  submitting.value = false;
};

/*
 * 提交
 * */
const handleSubmitSSE = async () => {
  if (!props.appId) {
    return;
  }
  sseSubmitting.value = true;
  // 创建sse请求
  const eventSource = new EventSource(
    `http://localhost:8101/api/question/ai_generate/sse?appId=${props.appId}&questionNumber=${form.value.questionNumber}&optionNumber=${form.value.optionNumber}`
  );
  // 接收消息
  let first = true;
  eventSource.onmessage = function (event) {
    if (first) {
      props.onSSEStart(event);
      handleCancel();
      first = !first;
    }
    console.log(event.data);
    props.onSSESuccess?.(JSON.parse(event.data));
  };
  // 报错或连接失败触发
  eventSource.onerror = function (event) {
    if (event.eventPhase == EventSource.CLOSED) {
      console.log("关闭连接");
      eventSource.close();
      props.onSSEClose?.(event);
      handleCancel();
    } else {
      eventSource.close();
    }
  };

  sseSubmitting.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_button, {
      type: "outline",
      onClick: handleClick
    }, {
      default: _withCtx(() => _cache[3] || (_cache[3] = [
        _createTextVNode("AI 生成题目")
      ])),
      _: 1
    }),
    _createVNode(_component_a_drawer, {
      visible: visible.value,
      width: 340,
      unmountOnClose: "",
      onCancel: handleCancel,
      onOk: handleOk
    }, {
      title: _withCtx(() => _cache[4] || (_cache[4] = [
        _createTextVNode(" AI 生成题目")
      ])),
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: form.value,
          "auto-label-width": "",
          "label-align": "left",
          onSubmit: handleSubmit
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "应用id" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.appId), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "questionNumber",
              label: "题目数量"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  modelValue: form.value.questionNumber,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.questionNumber) = $event)),
                  max: "20",
                  min: "1",
                  placeholder: "请输入题目数量"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "optionNumber",
              label: "选项数量",
              max: "6",
              min: "1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: form.value.optionNumber,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.optionNumber) = $event)),
                  placeholder: "请输入选项数量"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      loading: submitting.value,
                      "html-type": "submit",
                      style: {"width":"120px"},
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(submitting.value ? "生成中" : "一键生成"), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"]),
                    _createVNode(_component_a_button, {
                      loading: sseSubmitting.value,
                      style: {"width":"120px"},
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (handleSubmitSSE()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(sseSubmitting.value ? "生成中" : "实时生成"), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})